import SchoolPersonalInformation from './SchoolPersonalInformation.page';

export default SchoolPersonalInformation;